function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconFeatherCheck = function SvgIconFeatherCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.63 7.778",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m13.8 9-5.362 5.364L6 11.926",
    className: "icon_feather_check_svg__cls-1",
    "data-name": "Icon feather-check",
    style: {
      fill: "none",
      stroke: "#ee751c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(-4.586 -7.586)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconFeatherCheck);
export default ForwardRef;